/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigResponse } from '../../models/config-response';
import { CreateConfigRequestDto } from '../../models/create-config-request-dto';

export interface CreateConfig$Params {
      body: CreateConfigRequestDto
}

export function createConfig(http: HttpClient, rootUrl: string, params: CreateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigResponse>> {
  const rb = new RequestBuilder(rootUrl, createConfig.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfigResponse>;
    })
  );
}

createConfig.PATH = '/configs';
